import { render, staticRenderFns } from "./TaxReportingDatabase.vue?vue&type=template&id=75ca8bb6&scoped=true&"
import script from "./TaxReportingDatabase.vue?vue&type=script&lang=js&"
export * from "./TaxReportingDatabase.vue?vue&type=script&lang=js&"
import style0 from "./TaxReportingDatabase.vue?vue&type=style&index=0&id=75ca8bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca8bb6",
  null
  
)

export default component.exports